document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('[data-soqia-faq]');

  sections.forEach((section) => {
    if (section.dataset.faqReady === 'true') return;
    section.dataset.faqReady = 'true';

    const items = Array.from(section.querySelectorAll('.sq-faq__item'));
    if (!items.length) return;

    function closeOthers(currentItem) {
      items.forEach((item) => {
        if (item !== currentItem) item.removeAttribute('open');
      });
    }

    items.forEach((item) => {
      item.addEventListener('toggle', function () {
        if (item.open) closeOthers(item);
      });
    });

    document.addEventListener('shopify:block:select', function (event) {
      const block = event.target.closest('.sq-faq__item');
      if (!block || !section.contains(block)) return;

      closeOthers(block);
      block.setAttribute('open', '');
      block.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
});